import {
  useGetReceiptBatchListPhoenix,
  usePliantTransactions,
  getIncompletePliantTransactionsParams,
  useReceiptsPhoenix,
} from '@pflegenavi/frontend/api-nursing-home';
import { IncompleteTransactionsCountContext } from '@pflegenavi/frontend/layout';
import {
  useNursingHomeContext,
  useSelectedEmployeeIds,
} from '@pflegenavi/frontend/nursing-home-context';
import { ReceiptStatusValues } from '@pflegenavi/shared/api';
import * as React from 'react';

export const IncompleteTransactionsProvider = ({
  children,
}: {
  children: React.ReactElement;
}): JSX.Element => {
  const { selectedNursingHome } = useNursingHomeContext();
  const employeeIds = useSelectedEmployeeIds();

  const { data: receipts, isLoading } = useReceiptsPhoenix(
    {
      nursing_home_ids: selectedNursingHome ? [selectedNursingHome.id] : [],
      page: 1,
      page_size: 1,
      receipt_states: [
        ReceiptStatusValues.INCOMPLETE,
        ReceiptStatusValues.DRAFT,
      ],
      created_by_employee_ids: employeeIds,
    },
    {
      staleTime: 0,
    }
  );

  const { data: receiptBatches, isPending: isLoadingReceiptBatchCount } =
    useGetReceiptBatchListPhoenix(
      {
        params: {
          nursing_home_ids: selectedNursingHome ? [selectedNursingHome.id] : [],
          page: 1,
          page_size: 1,
          status: null,
          created_by_employee_ids: employeeIds,
        },
      },
      {
        staleTime: 0,
      }
    );

  const { data: pliantTransactions, isLoading: isLoadingPliantTransactions } =
    usePliantTransactions(
      getIncompletePliantTransactionsParams(
        1,
        10,
        selectedNursingHome,
        employeeIds
      )
    );

  const countReceipts =
    isLoading && isLoadingReceiptBatchCount
      ? 0
      : (receipts?.meta?.total_count ?? 0) +
        (receiptBatches?.meta?.total_count ?? 0);
  const countPliant = isLoadingPliantTransactions
    ? 0
    : pliantTransactions?.meta?.total_count ?? 0;

  return (
    <IncompleteTransactionsCountContext.Provider
      value={{
        all: countReceipts + countPliant,
        receipts: countReceipts,
        pliantTransactions: countPliant,
      }}
    >
      {children}
    </IncompleteTransactionsCountContext.Provider>
  );
};
